import { CobrowseOriginEnum, CobrowseStateEnum } from "../../models";
import { BaseMetadata } from "../../models/Metadata";
import { IEndpointMetadata } from "../../models/IEndpointMetadata";
import { CobrowsePermissionEnum } from "../../models/enums";
import { CobrowseRequestType } from "@auvious/integrations";

export enum CobrowseActions {
  COBROWSE_STATE_CHANGE = "COBROWSE_STATE_CHANGE",
  COBROWSE_ORIGIN_CHANGE = "COBROWSE_ORIGIN_CHANGE",
  COBROWSE_METADATA_CHANGE = "COBROWSE_METADATA_CHANGE",
  COBROWSE_REMOTE_ENDPOINT_METADATA_CHANGE = "COBROWSE_REMOTE_ENDPOINT_METADATA_CHANGE",
  COBROWSE_TICKET_CHANGE = "COBROWSE_TICKET_CHANGE",
  COBROWSE_PERMISSION_CHANGE = "COBROWSE_PERMISSION_CHANGE",
  COBROWSE_RESET = "COBROWSE_RESET",
  COBROWSE_REQUEST_TYPE_CHANGE = "COBROWSE_REQUEST_TYPE_CHANGE",
}

export interface CobrowseStateChange {
  type: CobrowseActions.COBROWSE_STATE_CHANGE;
  payload: CobrowseStateEnum;
}
export interface CobrowseOriginChange {
  type: CobrowseActions.COBROWSE_ORIGIN_CHANGE;
  payload: CobrowseOriginEnum;
}
export interface CobrowseMetadataChange {
  type: CobrowseActions.COBROWSE_METADATA_CHANGE;
  payload: BaseMetadata;
}
export interface CobrowseRemoteEndpointMetadataChange {
  type: CobrowseActions.COBROWSE_REMOTE_ENDPOINT_METADATA_CHANGE;
  payload: IEndpointMetadata;
}
export interface CobrowseTicketChange {
  type: CobrowseActions.COBROWSE_TICKET_CHANGE;
  payload: string;
}
export interface CobrowseReset {
  type: CobrowseActions.COBROWSE_RESET;
}
export interface CobrowsePermissionChange {
  type: CobrowseActions.COBROWSE_PERMISSION_CHANGE;
  payload: { [key in CobrowsePermissionEnum]?: boolean };
}

export interface CobrowseRequestTypeChange {
  type: CobrowseActions.COBROWSE_REQUEST_TYPE_CHANGE;
  payload: CobrowseRequestType;
}

export const dispatchCobrowseStateChange =
  (payload: CobrowseStateEnum) => (dispatch, _getState) => {
    return dispatch({
      type: CobrowseActions.COBROWSE_STATE_CHANGE,
      payload,
    } as CobrowseStateChange);
  };
export const dispatchCobrowseOriginChange =
  (payload: CobrowseOriginEnum) => (dispatch, _getState) => {
    return dispatch({
      type: CobrowseActions.COBROWSE_ORIGIN_CHANGE,
      payload,
    } as CobrowseOriginChange);
  };
export const dispatchCobrowseMetadataChange =
  (payload: BaseMetadata) => (dispatch, _getState) => {
    return dispatch({
      type: CobrowseActions.COBROWSE_METADATA_CHANGE,
      payload,
    } as CobrowseMetadataChange);
  };
export const dispatchCobrowseRemoteEndpointMetadataChange =
  (payload: IEndpointMetadata) => (dispatch, _getState) => {
    return dispatch({
      type: CobrowseActions.COBROWSE_REMOTE_ENDPOINT_METADATA_CHANGE,
      payload,
    } as CobrowseRemoteEndpointMetadataChange);
  };
export const dispatchCobrowseTicketChange =
  (payload: string) => (dispatch, _getState) => {
    return dispatch({
      type: CobrowseActions.COBROWSE_TICKET_CHANGE,
      payload,
    } as CobrowseTicketChange);
  };
export const dispatchCobrowsePermissionChange =
  (payload: { [key in CobrowsePermissionEnum]?: boolean }) =>
  (dispatch, _getState) => {
    return dispatch({
      type: CobrowseActions.COBROWSE_PERMISSION_CHANGE,
      payload,
    } as CobrowsePermissionChange);
  };
export const dispatchCobrowseReset = () => (dispatch, _getState) => {
  return dispatch({
    type: CobrowseActions.COBROWSE_RESET,
  } as CobrowseReset);
};
export const dispatchCobrowseRequestTypeChange =
  (payload: CobrowseRequestType) => (dispatch, _getState) => {
    return dispatch({
      type: CobrowseActions.COBROWSE_REQUEST_TYPE_CHANGE,
      payload,
    } as CobrowseRequestTypeChange);
  };
